import React from 'react';
import { Container, Grid, Typography, Button, Box } from '@mui/material';

const HeroSection = ({ t, navigate, currentLang }) => (
    <Container>
        <Grid container sx={{ alignItems: 'center', justifyContent: 'center', px: 2, py: 4, mb: 5 }}>
            <Grid item xs={12} md={6}>
                <Typography
                    variant="h1"
                    color='primary'
                    sx={{
                        fontSize: { xs: '3.5rem', sm: '4rem', md: '5rem', lg: '6rem' },
                        fontWeight: 700,
                        lineHeight: { xs: '3.5rem', sm: '4rem', md: '5rem', lg: '6rem' },
                        WebkitBackgroundClip: 'text',
                    }}
                >
                    {t('hero_headline')}
                </Typography>
                <Typography
                    component="h2"
                    variant="h5"
                    sx={{
                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                        mt: { xs: 2, sm: 5 },
                        mb: 5
                    }}
                >
                    {t('hero_subheadline')}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
                    <Button onClick={() => navigate(`/${currentLang}/create`)} variant="contained" color="primary">{t('hero_cta')}</Button>
                </Box>
            </Grid>
            <Grid item
                xs={12} md={6}
                sx={{
                    marginTop: { xs: 4, md: 0 },
                    padding: '0!important',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: { xs: 'center', md: 'right' }
                }}>
                <Box component='img' alt='WithLove' src={require('../../assets/img/hero-image.webp')} sx={{ width: { xs: '80%', sm: '60%', md: '80%' } }} />
            </Grid>
        </Grid>
    </Container>
);

export default HeroSection;